import React from "react";

const CurrencyFormatter = ({ amount, locale = "en-US", currency = "USD" }) => {
  const formattedAmount = new Intl.NumberFormat(locale, {
    currency,
    // style: "currency",
  }).format(amount)

  return <span>{formattedAmount}</span>;
};

export default CurrencyFormatter;
